<script>
import { getColorVariant, getVariant } from "../../helpers/badgeLookupTable";
import StackedChart from "./StackedChart.vue";
/*

    'estado_aforo'  => [
        'Presentado',
        'Sin observaciones',
        'Retirado con multa',
        'Retención'
*/

export default {
  components: { StackedChart },
  props: {
    data: {
      type: Object,
      required: false,
    },
    irADespachosPendientes: Function,
  },
  data() {
    return {};
  },
  computed: {
    parsedData() {
      return [
        {
          label: "Presentado",
          value: this.data?.presentado,
          color: getColorVariant("Presentado"),
        },
        {
          label: "Sin observaciones",
          value: this.data?.sin_observaciones,
          color: getColorVariant("Sin observaciones"),
        },
        {
          label: "Retirado con multa",
          value: this.data?.retirado_con_multa,
          color: getColorVariant("Retirado con multa"),
        },
        {
          label: "Retenido",
          value: this.data?.retenido,
          color: getColorVariant("Retenido"),
        },
      ];
    },
  },
  methods: {
    getVariant(estado) {
      return getVariant(estado);
    },
  },
};
</script>

<template>
  <div id="charts" class="flex flex-col gap-2 h-full">
    <!--
    <div class="mx-auto">
      <slot name="ver"></slot>
    </div>
    -->
    <h1 class="!text-xl !font-bold text-left">Aforos</h1>

    <div class="flex flex-row justify-between gap-4 p-4">
      <div class="w-56">
        <stacked-chart :data="parsedData" />
      </div>

      <div class="flex flex-col gap-4 w-full">
        <div
          v-for="(estado, i) in parsedData"
          :key="i"
          class="flex flex-row items-center gap-2"
        >
          <div class="h-4 w-4 rounded-full aspect-square" :class="[getVariant(estado.label)]"></div>
          <span
            class="cursor-pointer text-left"
            @click="
              irADespachosPendientes({
                estado: true,
                text: 'Estado Aforo',
                value: estado.label,
                filtro: 'aforo_presentado',
              })
            "
          >
            {{ estado.label }}
          </span>
        </div>
      </div>
    </div>
  </div>
</template>
